import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="details-accordion"
export default class extends Controller {
	connect() {
		this.summary = this.element.firstElementChild
		this.content = this.summary?.nextElementSibling

		if (!this.summary || !this.content?.classList.contains("accordion-content")) return

		this.boundToggle = this.toggle.bind(this)
		this.boundTransitionEnd = this.handleTransitionEnd.bind(this)
		this.isClosing = false
		this.isExpanding = false

		this.content.style.overflow = "hidden"
		this.content.style.transition = "max-height 220ms ease, opacity 220ms ease"

		if (this.element.open) {
			this.content.style.maxHeight = "none"
			this.content.style.opacity = "1"
		} else {
			this.content.style.maxHeight = "0px"
			this.content.style.opacity = "0"
		}

		this.summary.addEventListener("click", this.boundToggle)
		this.content.addEventListener("transitionend", this.boundTransitionEnd)
	}

	disconnect() {
		if (!this.summary || !this.content) return

		this.summary.removeEventListener("click", this.boundToggle)
		this.content.removeEventListener("transitionend", this.boundTransitionEnd)
	}

	toggle(event) {
		if (this.ignoreClick(event)) return

		event.preventDefault()

		if (this.element.open) {
			this.collapse()
		} else {
			this.expand()
		}
	}

	expand() {
		this.isClosing = false
		this.isExpanding = true

		this.element.open = true
		this.content.style.maxHeight = `${this.content.offsetHeight}px`
		this.content.style.opacity = this.content.offsetHeight > 0 ? "1" : "0"

		requestAnimationFrame(() => {
			this.content.style.maxHeight = `${this.content.scrollHeight}px`
			this.content.style.opacity = "1"
		})
	}

	collapse() {
		this.isExpanding = false
		this.isClosing = true

		const startHeight = this.content.offsetHeight || this.content.scrollHeight
		this.content.style.maxHeight = `${startHeight}px`
		this.content.style.opacity = "1"

		requestAnimationFrame(() => {
			this.content.style.maxHeight = "0px"
			this.content.style.opacity = "0"
		})
	}

	handleTransitionEnd(event) {
		if (event.target !== this.content || event.propertyName !== "max-height") return

		if (this.isClosing) {
			this.element.open = false
			this.isClosing = false
			return
		}

		if (this.isExpanding) {
			this.content.style.maxHeight = "none"
			this.isExpanding = false
		}
	}

	ignoreClick(event) {
		if (event.defaultPrevented) return true

		const interactiveTarget = event.target.closest("a, button, input, select, textarea, label")
		return interactiveTarget && interactiveTarget !== this.summary
	}
}
